import { exec } from "jadelet"
export default exec(["form",{"submit":{"bind":"confirm"},"tabindex":"-1"},[["h1",{},[{"bind":"title"}]],["p",{},[{"bind":"message"}]],{"bind":"inputElement"},["button",{},["OK"]],{"bind":"cancelButton"}]])